import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { useSelector } from 'hooks/redux'
import { getIsSimulating } from 'selectors/navigator'
import { Icon } from 'components/patterns'
import { themeColor } from 'utils/styles'
import {
  OUTPUT,
  DIGITAL_INPUT,
  ANALOG_INPUT,
  NATIVE_INPUT,
  CAN_INPUT,
  SWITCH_INPUT,
} from 'utils/constants'

const LineWrap = styled.span`
  && {
    display: flex;
    align-items: center;
    margin-top: 24px;
    margin-bottom: 18px;
    span {
      font-size: 12px;
      line-height: 16px;
    }
    svg {
      margin-right: 5px;
      path {
        fill: ${themeColor('featureSimulatedValueResetIcon')};
      }
    }
  }
`

const messageMap = {
  [OUTPUT]: strings.simulate_outputs_not_supported,
  [DIGITAL_INPUT]: strings.simulate_digital_input_not_supported,
  [ANALOG_INPUT]: strings.simulate_analog_input_not_supported,
  [NATIVE_INPUT]: strings.simulate_native_input_not_supported,
  [CAN_INPUT]: strings.simulate_can_input_not_supported,
  [SWITCH_INPUT]: strings.simulate_switch_input_not_supported,
}

const UnsupportedLine = ({ parentType }) => {
  const isSimulating = useSelector(getIsSimulating)
  if (!isSimulating) {
    return null
  }

  return (
    <LineWrap>
      <Icon icon="alert_solid" size="large" />
      <span>{messageMap[parentType]}</span>
    </LineWrap>
  )
}

UnsupportedLine.propTypes = {
  parentType: PropTypes.oneOf([
    OUTPUT,
    DIGITAL_INPUT,
    ANALOG_INPUT,
    NATIVE_INPUT,
    CAN_INPUT,
    SWITCH_INPUT,
  ]),
}

export default UnsupportedLine
